import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import Grid from "@material-ui/core/Grid";
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import {EnteroSolo, FieldsJs} from "../../../../settings/General/General";
import Slide from "@material-ui/core/Slide";
import {SolicitudPagoService} from "../../../../services/_Sis/SolicitudPagoService/SolicitudPagoService";
import {BotonAccionAbrirModal, BotonAccionFooterModal, TituloHeaderModal} from "../../../Include/MiniComponents/GlobalComponent";
import {
	AccountBalance,
	HdrWeakOutlined,
	Person,
	Comment,
	FiberManualRecord,
	AccountTree,
	DeleteOutlined,
	AddOutlined, AttachMoney, CreditCard
} from "@material-ui/icons";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {CONFIG} from "../../../../settings/Config/Config";
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";
import Zoom from '@material-ui/core/Zoom/index';
import Button from "@material-ui/core/Button";


class ModalDatos extends Component {
	
	state = {};
	
	Usr = {};
	
	constructor(props) {
		super(props);
		
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		
		this.state = {
			modal: {
				open: false
			},
			
			tipo: props.tipo,
			
			id_solicitud_pago: props.item.id_solicitud_pago || '',
			no_recibo: '',
			id_usuario: '',
			id_cat_area_proyecto: '',
			id_cat_etapa_proyecto: '',
			id_cat_subetapa_proyecto: '',
			descripcion: '',
			id_proveedor: '',
			beneficiario: '',
			cantidad: '',
			precio_unitario: '',
			importe: '',
			id_cat_tipo_pago: '',
			factura: '',
			id_cat_banco: '',
			tarjeta: '',
			usuario: '',
			total: '',
			subtotal: '',
			iva: '',
			banco: '',
			proveedor: '',
			tipo_pago: '',
			comentarios: '',
			numero_cuenta: '',
			numero_tarjeta: '',
			descripcion_general: '',
			
			partidas: [],
			cat_usuario: [],
			cat_tipo_pago: [],
			cat_banco: [],
			cat_area_proyecto: [],
			cat_etapa_proyecto: [],
			cat_subetapa_proyecto: [],
			cat_clase: [],
			cat_subclase: [],
			cat_proveedor: [],
			
			activo: true,
			
		};
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	openModal = () => {
		const props = this.props;
		this.setState({
			modal: {
				open: true
			}
		});
		
		console.log(this.state, props);
	};
	
	open = () => {
		this.init().then(r => {
			setTimeout(() => this.openModal());
		}).catch(e => {
			console.log(e);
		});
	};
	
	RefreshInit = () => {
		this.init();
	};
	
	init = () => {
		return new Promise((resolve) => {
			resolve(true);
		});
	};
	
	is_view = () => {
		return this.props.tipo === 'view';
	};
	
	is_root = () => {
		return FieldsJs.inArray([1], this.Usr.id_cat_tipo_usuario);
	};
	
	view = () => {
		const {item} = this.props;
		
		this.props.ListProveedor().then((response) => {
			this.setState({
				cat_proveedor: response.data,
			});
		});
		
		this.props.ListUsuario().then((response) => {
			this.setState({
				cat_usuario: response.data,
			});
		});
		
		this.props.ListBanco().then((response) => {
			this.setState({
				cat_banco: response.data,
			});
		});
		
		this.props.ListTipoPago().then((response) => {
			this.setState({
				cat_tipo_pago: response.data,
			});
		});
		
		this.props.ListAreaProyecto().then((response) => {
			this.setState({
				cat_area_proyecto: response.data,
			});
		});
		
		this.props.ListSubEtapaProyecto().then((response) => {
			this.setState({
				cat_subetapa_proyecto: response.data,
			});
		});
		
		this.props.ListEtapaProyecto(item.id_cat_area_proyecto).then((response) => {
			this.setState({
				cat_etapa_proyecto: response.data,
				id_cat_etapa_proyecto: item.id_cat_etapa_proyecto || ''
			});
		})
		
		if (FieldsJs.Field(item.id_cat_subetapa_proyecto)) {
			this.props.ListSubEtapaProyecto(item.id_cat_etapa_proyecto).then((response) => {
				this.setState({
					cat_subetapa_proyecto: response.data,
					id_cat_subetapa_proyecto: item.id_cat_subetapa_proyecto || ''
				});
			})
		} else {
			this.setState({
				id_cat_subetapa_proyecto: ''
			});
		}
		
		this.props.ListClase().then((response) => {
			this.setState({
				cat_clase: response.data,
				id_cat_clase: item.id_cat_clase || ''
			});
		});
		
		if (FieldsJs.Field(item.id_cat_clase)) {
			this.props.ListSubClase(item.id_cat_clase).then((response) => {
				this.setState({
					cat_subclase: response.data,
					id_cat_subclase: item.id_cat_subclase || ''
				});
			})
		} else {
			this.setState({
				id_cat_subclase: ''
			});
		}
		
		this.setState({
			id_solicitud_pago: item.id_solicitud_pago || '',
			beneficiario: item.beneficiario || item.nombre_completo || '',
			banco: item.banco || '',
			numero_cuenta: item.numero_cuenta || '',
			numero_tarjeta: item.numero_tarjeta || '',
			descripcion_general: item.descripcion_general || '',
			no_recibo: item.no_recibo || '',
			id_usuario: item.id_usuario || '',
			id_cat_area_proyecto: item.id_cat_area_proyecto || '',
			comentarios: item.comentarios || '',
			total: item.total || '',
			subtotal: item.subtotal || '',
			iva: item.iva || '',
			partidas: item.partidas || [],
			
			activo: true
		});
		
		this.open();
	};
	
	delete = (value, key) => {
		try {
			PopupService.Confirm(['Cancelar', 'Aceptar'], 'warning', CONFIG.titulo_alert_confirm, '¿Deseas eliminar el contacto?').then((r) => {
				if (r.button === 'Aceptar') {
					let lista_contactos = FieldsJs.Copy(this.state.lista_contactos);
					
					lista_contactos.splice(key, 1);
					
					this.setState({
						lista_contactos: lista_contactos
					});
				}
			});
			
		} catch (error) {
			this.showSnackBars('error', error.mensaje);
		}
	};
	
	is_edited_product = () => {
		return this.state.key !== null && this.state.key > -1;
	};
	
	agregarPartida = () => {
		try {
			
			/*if (!this.state.clave_concepto) {
				throw Object({
					status: false, mensaje: 'Campo requerido: Clave Concepto.'
				})
			}*/
			
			let partidas = FieldsJs.Copy(this.state.partidas);
			//let productos = FieldsJs.Copy(this.state.listar_concepto);
			
			for (let i = 0; i < partidas.length; i++) {
				const cantidad = parseFloat(partidas[i].cantidad) || 0;
				const precioUnitario = parseFloat(partidas[i].precio_unitario) || 0;
				
				const importe = cantidad * precioUnitario;
				
				const iva = importe * 0.16;
				
				const totalConIva = importe + iva;
				
				console.log("handleChangeImporte >>>>> ", importe,iva,totalConIva);
				
				partidas[i].iva = iva.toFixed(2);
				partidas[i].total_con_iva = totalConIva.toFixed(2);
			}
			
			
			let item = {
				descripcion: this.state.descripcion || '',
				id_proveedor: this.state.id_proveedor || '',
				cantidad: this.state.cantidad || '',
				precio_unitario: this.state.precio_unitario || '',
				importe: this.state.importe || '',
				id_cat_tipo_pago: this.state.id_cat_tipo_pago || '',
				factura: this.state.factura || '',
				id_cat_banco: this.state.id_cat_banco || '',
				tarjeta: this.state.tarjeta || '',
				banco: this.state.banco || '',
				proveedor: this.state.proveedor || '',
				beneficiario: this.state.beneficiario || '',
				tipo_pago: this.state.tipo_pago || '',
			};
			
			partidas.push(item);
			
			this.setState({
				
				descripcion: '',
				id_proveedor: '',
				cantidad: '',
				precio_unitario: '',
				importe: '',
				id_cat_tipo_pago: '',
				factura: '',
				id_cat_banco: '',
				tarjeta: '',
				banco: '',
				proveedor: '',
				beneficiario: '',
				tipo_pago: '',
				partidas: partidas,
			});
			
			setTimeout(() => {
				let desglose = this.calcularDesgoseTotales();
				this.setState({
					desglose: desglose
				});
			}, 800);
			
		} catch (e) {
			this.props.showSnackBars('error', e.mensaje);
		}
	};
	
	selectUsuario = (id_usuario) => {
		let user = '';
		for (let i = 0; i < this.state.cat_usuario.length; i++) {
			if (Number(id_usuario) === Number(this.state.cat_usuario[i].id_usuario)) {
				user = this.state.cat_usuario[i].nombre_completo;
			}
		}
		
		this.setState({
			usuario: user
		});
	}
	
	selectProveedor = (id_proveedor) => {
		let prov = '';
		let tarj = '';
		for (let i = 0; i < this.state.cat_proveedor.length; i++) {
			if (Number(id_proveedor) === Number(this.state.cat_proveedor[i].id_proveedor)) {
				prov = this.state.cat_proveedor[i].nombre_razon_social;
				tarj = this.state.cat_proveedor[i].cuenta_bancaria ? this.state.cat_proveedor[i].cuenta_bancaria.numero_tarjeta ? this.state.cat_proveedor[i].cuenta_bancaria.clabe : '' : '';
			}
		}
		
		this.setState({
			proveedor: prov,
			tarjeta: tarj
		});
	}
	
	selectTipoPago = (id_cat_tipo_pago) => {
		let tp = '';
		for (let i = 0; i < this.state.cat_tipo_pago.length; i++) {
			if (Number(id_cat_tipo_pago) === Number(this.state.cat_tipo_pago[i].id_cat_tipo_pago)) {
				tp = this.state.cat_tipo_pago[i].tipo_pago;
			}
		}
		this.setState({
			factura: Number(id_cat_tipo_pago) === 2 ? '1':'2',
			tipo_pago: tp
		});
	}
	
	selectBanco = (id_cat_banco) => {
		let bc = '';
		for (let i = 0; i < this.state.cat_banco.length; i++) {
			if (Number(id_cat_banco) === Number(this.state.cat_banco[i].id_cat_banco)) {
				bc = this.state.cat_banco[i].banco;
			}
		}
		this.setState({
			banco: bc
		});
	}
	
	
	render() {
		
		let funcion;
		
		switch (this.state.tipo) {
			case 'edit':
				funcion = this.edit;
				break;
			case 'add':
				funcion = this.add;
				break;
			case 'view':
				funcion = this.view;
				break;
			default:
				funcion = () => {
				};
		}
		
		return (
			<div>
				
				{this.props.componente ? (
					<Fragment>
						<span
							style={{cursor: 'pointer'}}
							children={this.props.componente}
							onClick={() => funcion()}
						/>
					</Fragment>
				) : (
					<BotonAccionAbrirModal
						id={this.state.id_solicitud_pago}
						tipo={this.state.tipo}
						onClick={() => funcion()}
					/>
				)}
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'md'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogTitle>
						<TituloHeaderModal
							tipo={this.state.tipo}
							titulo={'Solicitud de Pago'}
						/>
					</DialogTitle>
					
					<DialogContent>
						
						
						<Grid container spacing={2}>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={4} lg={4} xl={4}>
								<Grid container spacing={1} alignItems={"flex-end"}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<strong>No. Recibo:</strong>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										{this.state.no_recibo}
									</Grid>
								</Grid>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={4} lg={4} xl={4}>
								<Grid container spacing={1} alignItems={"flex-end"}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<strong>Usuario Solicitante:</strong>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										{this.state.beneficiario}
									</Grid>
								</Grid>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={4} lg={4} xl={4}>
								<Grid container spacing={1} alignItems={"flex-end"}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<strong>Proyecto:</strong>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										{this.state.cat_area_proyecto.map((option) => {
											return option.id_cat_area_proyecto === this.state.id_cat_area_proyecto ? option.area_proyecto : null
										})}
									</Grid>
								</Grid>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={3} lg={3} xl={3}>
								<Grid container spacing={1} alignItems={"flex-end"}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<strong>Etapa:</strong>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										{this.state.cat_etapa_proyecto.map((option) => {
											return option.id_cat_etapa_proyecto === this.state.id_cat_etapa_proyecto ? option.etapa : null
										})}
									</Grid>
								</Grid>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={3} lg={3} xl={3}>
								<Grid container spacing={1} alignItems={"flex-end"}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<strong>Sub-Etapa:</strong>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										{this.state.cat_subetapa_proyecto.map((option) => {
											return option.id_cat_subetapa_proyecto === this.state.id_cat_subetapa_proyecto ? option.subetapa : null
										})}
									</Grid>
								</Grid>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={3} lg={3} xl={3}>
								<Grid container spacing={1} alignItems={"flex-end"}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<strong>Clase:</strong>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										{this.state.cat_clase.map((option) => {
											return option.id_cat_clase === this.state.id_cat_clase ? option.clase : null
										})}
									</Grid>
								</Grid>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={3} lg={3} xl={3}>
								<Grid container spacing={1} alignItems={"flex-end"}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<strong>Sub-Clase:</strong>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										{this.state.cat_subclase.map((option) => {
											return option.id_cat_subclase === this.state.id_cat_subclase ? option.subclase : null
										})}
									</Grid>
								</Grid>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={3} lg={3} xl={3}>
								<Grid container spacing={1} alignItems={"flex-end"}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<strong>Banco:</strong>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										{this.state.banco ? this.state.banco:''}
									</Grid>
								</Grid>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={3} lg={3} xl={3}>
								<Grid container spacing={1} alignItems={"flex-end"}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<strong>Cuenta:</strong>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										{this.state.numero_cuenta ? this.state.numero_cuenta: this.state.numero_tarjeta ? this.state.numero_tarjeta: ''}
									</Grid>
								</Grid>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={3} lg={3} xl={3}>
								<Grid container spacing={1} alignItems={"flex-end"}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<strong>Tarjeta:</strong>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										{this.state.numero_tarjeta ? this.state.numero_tarjeta:''}
									</Grid>
								</Grid>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={3} lg={3} xl={3}>
								<Grid container spacing={1} alignItems={"flex-end"}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<strong>Total:</strong>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										{this.state.total ? '$'+FieldsJs.Currency(this.state.total):''}
									</Grid>
								</Grid>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={12} lg={12} xl={12}>
								<Grid container spacing={1} alignItems={"flex-end"}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<strong>Descripción General:</strong>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										{this.state.descripcion_general ? this.state.descripcion_general:'N/A'}
									</Grid>
								</Grid>
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={12} lg={12} xl={12}>
								<Grid container spacing={1} alignItems={"flex-end"}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										<strong>Observaciones:</strong>
									</Grid>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										{this.state.comentarios ? this.state.comentarios:'N/A'}
									</Grid>
								</Grid>
							</Grid>
							
							{this.state.partidas.length > 0 ? (
								<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
									<table className={'desing-mark'}>
										<thead>
										<tr>
											<th align={"center"}>No.</th>
											<th align={"center"}>Descripción</th>
											<th align={"center"}>Proveedor</th>
											<th align={"center"}>Beneficiario</th>
											<th align={"center"}>Tipo Pago</th>
											<th align={"center"}>Banco</th>
											<th align={"center"}>Cantidad</th>
											<th align={"center"}>Precio Unitario</th>
											<th align={"center"}>Importe</th>
											<th align={"center"}>IVA (16%)</th>
											<th align={"center"}>Total con IVA</th>
										</tr>
										</thead>
										<tbody>
										{this.state.partidas.map((item, index) => (
											<tr key={index}>
												<td align={"center"}>{index + 1}</td>
												<td align={"center"}>{item.descripcion}</td>
												<td align={"center"}>{item.proveedor}</td>
												<td align={"center"}>{item.beneficiario_partida}</td>
												<td align={"center"}>{item.tipo_pago}</td>
												<td align={"center"}>{item.banco}</td>
												<td align={"center"}>{item.cantidad}</td>
												<td align={"right"}>${FieldsJs.Currency(item.precio_unitario)}</td>
												<td align={"right"}>${FieldsJs.Currency(item.importe)}</td>
												<td align={"center"}>{item.con_iva ? FieldsJs.Currency(item.iva):"-"}</td>
												<td align={"center"}>{item.con_iva ? FieldsJs.Currency(item.total_con_iva):"-"}</td>
											</tr>
										))}
										{this.state.partidas.length > 0 ? (
											<Fragment>
												<tr>
													<td colSpan={9} align={"right"}/>
													<td align={"right"} style={{fontWeight: 'bold'}}>Subtotal: </td>
													<td align={"right"} style={{fontWeight: 'bold'}}>${FieldsJs.Currency(this.state.subtotal)}</td>
												</tr>
												<tr>
													<td colSpan={9} align={"right"}/>
													<td align={"right"} style={{fontWeight: 'bold'}}>IVA: </td>
													<td align={"right"} style={{fontWeight: 'bold'}}>${FieldsJs.Currency(this.state.iva)}</td>
												</tr>
												<tr>
													<td colSpan={9} align={"right"}/>
													<td align={"right"} style={{fontWeight: 'bold'}}>TOTAL: </td>
													<td align={"right"} style={{fontWeight: 'bold'}}>${FieldsJs.Currency(this.state.total)}</td>
												</tr>
											</Fragment>
										):null}
										</tbody>
									</table>
								</Grid>
							) : null}
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<br/>
							</Grid>
						</Grid>
					
					</DialogContent>
					
					
					<DialogActions>
						<Button onClick={this.close} color="primary">
							{'Cerrar'}
						</Button>
					</DialogActions>
				
				</Dialog>
			
			</div>
		);
	}
}

ModalDatos.propTypes = {
	componente: PropTypes.element,
	tipo: PropTypes.string.isRequired,
	item: PropTypes.object.isRequired,
	ListUsuario: PropTypes.func.isRequired,
	ListProveedor: PropTypes.func.isRequired,
	ListBanco: PropTypes.func.isRequired,
	ListTipoPago: PropTypes.func.isRequired,
	ListAreaProyecto: PropTypes.func.isRequired,
	ListClase: PropTypes.func.isRequired,
	ListSubClase: PropTypes.func.isRequired,
	ListEtapaProyecto: PropTypes.func.isRequired,
	ListSubEtapaProyecto: PropTypes.func.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ModalDatos;
